import { Grid2 as Grid } from "@mui/material";
import React from "react";
import { useAppSelector } from "@store/hooks";
import { RightioWBSAPIModelsSPSpUsersGetStatisticsResult } from "@utils/apis/wbs/model";
import NumberedCircle from "./NumberedCircle";

const name = "RatiosTable";

type ExtendedStatistic = RightioWBSAPIModelsSPSpUsersGetStatisticsResult & {
    totalBookings: number,
    totalFails: number
}

interface Props {
    data: ExtendedStatistic[]
}

const RatiosTable: React.FC<Props> = ({ data }) => {
    // save data to the state
    const userId = useAppSelector(({ state }) => state.UserId);
    const [allBookingRate, setAllBookingRate] = React.useState(0);

    React.useEffect(() => {
        if (data.length > 0) {
            const allBookings = data.find(x => x.userId === userId)?.totalBookings ?? 0;
            const allFails = data.find(x => x.userId === userId)?.totalFails ?? 0;
            const allBookingRate = allBookings / (allBookings + allFails);
            setAllBookingRate(allBookingRate * 100);
        }
    }
        , [data, userId]);

    return (data && data.length > 0 && userId ? <Grid container width="36.2rem" alignItems="center" justifyContent="center">
        <Grid size={2.75}>
            <NumberedCircle innerColor="#fff" isPercentage={true} number={data.find(x => x.userId === userId)?.hitRate || 0} size={70} numberColor="#000" label="Hit Rate" />
            <NumberedCircle innerColor="#fff" isPercentage={true} number={data.find(x => x.userId === userId)?.carePlanRate || 0} size={70} numberColor="#000" label="Care Plan Rate" />
            <NumberedCircle innerColor="#fff" isPercentage={true} number={data.find(x => x.userId === userId)?.reducedRate || 0} size={70} numberColor="#000" inverted label="Reduced Rate" />
        </Grid>
        <Grid size={2.75}>
            <NumberedCircle innerColor="#fff" isPercentage={true} number={data.find(x => x.userId === userId)?.cardRate || 0} size={70} numberColor="#000" label="Card Rate" />
            <NumberedCircle innerColor="#fff" isPercentage={true} number={data.find(x => x.userId === userId)?.emailRate || 0} size={70} numberColor="#000" label="Emails Rate" />
            <NumberedCircle innerColor="#fff" isPercentage={true} number={allBookingRate || 0} size={70} numberColor="#000" label="Total Booking %" />
        </Grid>
        <Grid size={1}>

        </Grid>
        <Grid size={2.75}>
            <NumberedCircle innerColor="#fff" isPercentage={false} number={data.find(x => x.userId === userId)?.opportunities || 0} size={70} outerColor="#253d86" numberColor="#000" label="Calls" />
            <NumberedCircle innerColor="#fff" isPercentage={false} number={data.find(x => x.userId === userId)?.fails || 0} size={70} outerColor="#253d86" numberColor="#000" label="Fails" />
            <NumberedCircle innerColor="#fff" isPercentage={false} number={data.find(x => x.userId === userId)?.jobsReduced || 0} size={70} outerColor="#253d86" numberColor="#000" label="Jobs Reduced" />
        </Grid>
        <Grid size={2.75}>
            <NumberedCircle innerColor="#fff" isPercentage={false} number={data.find(x => x.userId === userId)?.bookings || 0} size={70} outerColor="#253d86" numberColor="#000" label="Bookings" />
            <NumberedCircle innerColor="#fff" isPercentage={false} number={data.find(x => x.userId === userId)?.carePlans || 0} size={70} outerColor="#253d86" numberColor="#000" label="Care Plans" />
            <NumberedCircle innerColor="#fff" isPercentage={true} number={data.find(x => x.userId === userId)?.bookingRate || 0} size={70} numberColor="#000" label="Booking Rate" />
        </Grid>
    </Grid> : null);
}

RatiosTable.displayName = name;

export default React.memo(RatiosTable);